<template>
  <div>
    <FITModal size="lg" ref="appointmentModal" reference="modal" :title="$t('crm.calendar.appointment.createBtn')" :customizedSessions="['footer']">
      <div slot="body">
        <!-- 
           events
           customer ID not required
           date  &&  time
           remarks
           meeting Address
         -->
        <b-row>
          <b-col cols=12>
            <FITTextInput :placeholder="$t('crm.calendar.appointment.eventPlaceholder')" :width="9" :label="$t('crm.calendar.appointment.event')" v-model="form.event" field="event" :rule="{required:true}"></FITTextInput>
            <FITAutoSearch :shouldPreventDefault="true" field="customer" :label="$t('crm.calendar.appointment.customer')" :width="9" v-model="selectedCustomer" v-bind="customerAutoSearchParams"></FITAutoSearch>
            <!-- {{selectedCustomer}} -->
            <FITDatePicker :width="9" :label="$t('crm.calendar.appointment.meetingDate')" v-model="form.meetingDate" field="meetingDate" :rule="{required:true}"></FITDatePicker>
            <FITTimepicker :disabledPlaceholder="$t('crm.calendar.appointment.allDayFlag')" :disabled="allDayFlag" format="HH:mm" :width="9" :label="$t('crm.calendar.appointment.meetingTime')" v-model="form.meetingTime"></FITTimepicker>
            <b-row class="my-3" align-v="center">
              <b-col cols="3">
                <span>{{$t('crm.calendar.appointment.allDayFlag')}}</span>
              </b-col>
              <b-col cols="9">
                <FITCheckbox v-model="allDayFlag" :width="9"></FITCheckbox>
              </b-col>
            </b-row>
            <FITTextInput :placeholder="$t('crm.calendar.appointment.address')" :width="9" :label="$t('crm.calendar.appointment.meetingAddress')" v-model="form.meetingAddress"></FITTextInput>
            <FITTextarea :placeholder="$t('crm.calendar.appointment.remarks')" :width="9" :label="$t('crm.calendar.appointment.remarks')" v-model="form.remarks"></FITTextarea>
          </b-col>
        </b-row>
      </div>
      <div slot="footer">
        <template v-if="modalType == 'create'">
           <FITButton size="md" class="float-right mx-3" variant="primary" @click="validationCheck('create')" :text=" $t('general.CURD.create') "></FITButton>
            <FITButton size="md" class="float-right" variant="default" @click="validationCheck('cancel')" :text=" $t('general.CURD.cancel') "></FITButton>
        </template>

        <template v-if="modalType == 'edit'">
      <FITButton size="md" class="float-right mx-3" variant="warning" @click="validationCheck('edit')" :text=" $t('general.CURD.edit') "></FITButton>
      <FITButton size="md" class="float-right" variant="danger" @click="validationCheck('delete')" :text=" $t('general.CURD.delete') "></FITButton>
        </template>

      </div>
    </FITModal>
    <FITFormCard>
      <h4 slot="header">
      <b-row align-v="center">
          <b-col cols="6">
            {{ $t('crm.calendar.header') }}
        </b-col>
        <b-col cols="6" class='text-right'>
          <b-btn  variant="primary" size="md" @click="openModal('create')">{{$t('crm.calendar.appointment.createBtn')}}</b-btn>
        </b-col>
      </b-row>
    </h4>
      <div slot="formBody">
        <b-row v-for="rows in 2" class=" mx-0 justify-content-end">
          <div v-if="index >= (rows-1)*4 && index < (rows)*4" v-for="(event,key,index) in eventIndicator.events" style="margin-left: 10px;">
            <svg width="12" height="12">
              <rect width="12" height="12" style="stroke:rgba(0,0,0,0.4);stroke-width:1; " :style="{fill:event.backgroundColor }" />
            </svg>
            <span>{{event.content}}</span>
          </div>
        </b-row>
        <b-row class="mx-0">
          <full-calendar :config="config" :events="events">
          </full-calendar>
        </b-row>
      </div>
    </FITFormCard>
  </div>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
import $ from 'jquery'
import DatePicker from 'vue2-datepicker'
import {mapState} from 'vuex'
import {
  FITFormCard,
  FITButton,
  FITModal,
  FITCheckbox,
  FITTextInput,
  FITTextarea,
  FITSelect,
  FITAutoSearch,
  FITDatePicker,
  FITTimepicker,
  FITValidationBus,

} from '@/components'

export default {
  name: 'CalendarView',
  components: {
    FITCheckbox,
    FITFormCard,
    FITButton,
    FITModal,
    FITTextInput,
    FITTextarea,
    FITSelect,
    FITAutoSearch,
    FITDatePicker,
    FITTimepicker,
    DatePicker,
  },
  computed: {
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
   ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
    }),
  },
  methods: {
    validationCheck(action) {
    this.modalAction = action;
    if(action == 'cancel'){
        this.$refs.appointmentModal.closeModal();
        return;
      }
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },
    getMousePosition(event) {
      console.log(event);
    },
    openModal(action) {
      this.modalInitial(action);
      this.$refs.appointmentModal.openModal();
    },
    modalInitial(action) {
      this.modalType = action;

      switch (action){
        default:
        case "create":
          Vue.set(this.form, 'meetingTime', moment().format('HH:mm:ss'));
          Vue.set(this.form, 'meetingDate', moment().format('YYYY-MM-DD'));
          Vue.set(this.form, 'event', '');
          Vue.set(this.form, 'meetingAddress', '');
          Vue.set(this.form, 'remarks', '');
          Vue.set(this.form, 'customerID', '');
          Vue.set(this, 'allDayFlag', false);
          Vue.set(this, 'selectedCustomer', { ID: -1 });
          FITValidationBus.$emit('reset',true);
        break;


        case "edit":
          // Get Appointment
              this.$store.dispatch('Crm/getAppointment', {
                  ID:this.currentAppointmentID
              })
              .then((response)=>{
                // console.log(response);
                let data = response.list[0];
                this.form = {
                  customerID : data.customerID,
                  event : data.event,
                  meetingAddress:data.meetingAddress,
                  meetingTime : data.meetingTime,
                  meetingDate: data.meetingDate,
                  remarks : data.remarks,
                };
                this.selectedCustomer = {
                  ID : data.customerID,
                  englishFullname : data.customerEnglishName,
                  chineseFullname : data.customerChineseName,
                  customerCode : data.customerCode
                };
                FITValidationBus.$emit('reset',true);
              });
        break;

      }
      
    },
    appointmentActionResponse(result){
      if(result == 'success'){
        this.getAllCalendar();
        this.$store.commit('Crm/setNotificationOnChangeState', { state: true });
        this.modalInitial('create');
        FITValidationBus.$emit('reset',true);
        this.$store.commit('Validation/validationReset');
        this.$refs.appointmentModal.closeModal();
      }
    },
    modalOnClick() {
      let event = this.modalAction;
      if (!event)
        return;
      // console.log(this.form);
      if(this.allDayFlag) {
          Vue.set(this.form, 'meetingTime', null);
      }
      if(this.modalType== "edit"){ // 
          Vue.set(this.form, 'ID', this.currentAppointmentID);
      }
      if(!confirm(`Are you confirm to ${event} this appointment ?`)){
        return;
      }
        this.$store.dispatch(`Crm/${event}Appointment`,this.form).then((json)=>{
          this.appointmentActionResponse('success');
        });      
    },
    replaceAll(str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace);
    },
    getAllCalendar(){
      let event = this.calEvent;
      let element = this.calElement;
      this.$store.dispatch('Crm/getCalendar', {
              start: event.start.format('YYYY-MM-DD'),
              end: event.end.format('YYYY-MM-DD'),
              simple: 1
            })
            .then((response) => {
              let convertedBirthday = response.birthday.map((birthday) => {
                let title = birthday.content;
                title = this.replaceAll(title, ',|:', '\n');
                return {
                  title: title,
                  allDay: true,
                  start: birthday.comingBirthday,
                  backgroundColor: this.eventIndicator.events.birthday.backgroundColor,
                  textColor: this.eventIndicator.textColor,
                  borderColor: this.eventIndicator.borderColor,
                  ID: birthday.ID,
                  type: 'B'
                }
              });

              let convertedMessage = response.message.map((message) => {
                let title = message.content;
                title = this.replaceAll(title, ',|:', '\n');
                let type = message.messageType;
                let backgroundColor;
                let url = `{"policyID":"${message.linkedEntityID}","type":"${message.messageType}",`;
                switch (type) {
                  case "P":
                    backgroundColor = this.eventIndicator.events.life.backgroundColor;
                    if (message.data) {
                      url = url + `"wfStep":"${message.data.workFlowStep}"}`;
                    }
                    break;
                  case "G":
                    backgroundColor = this.eventIndicator.events.GI.backgroundColor;
                    if (message.data) {
                      url = url + `"wfStep":"${message.data.workFlowStep}"}`;
                    }
                    break;
                  case "S":
                    backgroundColor = this.eventIndicator.events.service.backgroundColor;
                    if (message.data) {
                      url = url.replace(`"policyID":"${message.linkedEntityID}"`, `"policyID":"${message.data.linkedEntityID}"`);
                      url = url + `"linkedEntity":"${message.data.linkedEntity}","requestID":"${message.data.requestID}","serviceType":"${message.data.serviceType}","wfStep":"${message.data.workFlowStep}"}`;
                    }
                    break;
                  case "C":
                    backgroundColor = this.eventIndicator.events.claim.backgroundColor;
                    if (message.data) {
                      url = url + `"claimStatus":"${message.data.status}","claimID":"${message.data.ID}","wfStep":"${message.data.workFlowStep}"}`;
                    }
                    break;

                  default:
                    return {};
                    break;
                }
                if (!message.data) {
                  url = url.substring(0, url.length - 1);
                  url = url + "}";
                }
                return {
                  title: title,
                  allDay: true,
                  start: message.createTime,
                  backgroundColor: backgroundColor,
                  textColor: this.eventIndicator.textColor,
                  borderColor: this.eventIndicator.borderColor,
                  url: url,
                }
              });
              // TODO: renewal
              let convertedRenewal = response.renewal.map((renewal) => {
                let title = renewal.content;
                title = this.replaceAll(title, ',|:', '\n');
                // console.log(title);
                let renewalRemainDay = parseInt(renewal.renewalRemainDay);
                if (!renewalRemainDay) { renewalRemainDay = 90; }
                let updatedColor = 66 + Math.ceil(renewalRemainDay * 1.0 / 90 * 122);
                // console.log(updatedColor);
                let color = `rgb(255,${updatedColor},${updatedColor})`;
                let url = `{"type":"R","reminderDate":"${renewal.formattedNextPaymentDate}"}`;
                return {
                  title: title,
                  allDay: true,
                  start: renewal.reminderDate,
                  backgroundColor: color,
                  textColor: this.eventIndicator.textColor,
                  borderColor: this.eventIndicator.borderColor,
                  url: url,
                }
              });


    
              let convertedAppointment = response.appointment.map((appointment) => {
                let appointmentID = appointment.ID;
                let url = `{"type":"A","ID":"${appointmentID}"}`;
                let color = this.eventIndicator.events.appointment.backgroundColor;
                // let title = " "+appointment.event+'\n'+appointment.customerEnglishName+" "+appointment.customerChineseName+"\n"+appointment.meetingAddress;
                let title = "\n" + appointment.content;
                title = title.replace('at', '\n');
                let allDayEvent = true;
                if (appointment.meetingTime) {
                  allDayEvent = false;
                }
                return {
                  title: title,
                  allDay: allDayEvent,
                  start: `${appointment.meetingDate} ${appointment.meetingTime}`,
                  backgroundColor: color,
                  textColor: this.eventIndicator.textColor,
                  borderColor: this.eventIndicator.borderColor,
                  url: url,
                }
              });

              let result = convertedBirthday.concat(convertedMessage);
              result = result.concat(convertedRenewal);
              result = result.concat(convertedAppointment);
              Vue.set(this, 'events', result);
              // });

            });

    },


    directToDetail(string) {
      var data = JSON.parse(string);
      // console.log(data);
      var type = data.type;
      var wfStep = 0;
      if (data.wfStep) {
        wfStep = parseInt(data.wfStep);
      }
      switch (type) {
        case "P":
          this.$store.commit({ type: 'LifePolicy/setLifePolicyID', policyID: data.policyID });
          switch (wfStep) {
            case 8:
              this.$store.commit({ type: 'LifePolicy/setIsCompleted', value: true })
              this.$router.push({
                path: '/osm/life/detail',
                query: { ID: data.policyID }
              })
              return;
            case 5:
            case 6:
            case 7:
              this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', (wfStep + 1))
              break;
            case 4:
              this.$store.commit({ type: 'LifePolicy/setIsRejected', value: true })
            default:
              this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', wfStep)
              break;
          }
          this.$router.push('/osm/life/new');
          break;

        case "G":
          this.$store.commit({ type: 'GIPolicy/setGIPolicyID', policyID: data.policyID });
          switch (wfStep) {
            case 8:
              this.$store.commit({ type: 'GIPolicy/setIsCompleted', value: true })
              this.$router.push('/osm/gi/detail')
              return;
            case 5:
            case 6:
            case 7:
              this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', (wfStep + 1))
              break;
            case 4:
              this.$store.commit({ type: 'GIPolicy/setIsRejected', value: true })
            default:
              this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', wfStep)
              break;
          }
          this.$router.push('/osm/gi/new');
          break;

        case "S":
          this.$router.push({
            name: `serviceRequest-${data.serviceType.toLowerCase()}`,
            params: {
              ID: parseInt(data.requestID),
              policy: {
                policyID: data.policyID,
                policyType: data.linkedEntity
              }
            }
          })
          break;

        case "C":
          this.$store.commit({ type: 'Claim/setNextWorkFlowStep', nextStep: wfStep });
          this.$store.commit({ type: 'Claim/setClaimID', ID: parseInt(data.claimID) });
          var row = { ID: data.claimID };
          switch (data.claimStatus) {
            case 'R':
            case 'C':
              this.$router.push({
                name: 'Claim Detail',
                params: { detail: row }
              })
              break;
            default:
              this.$router.push({
                name: 'Create Claim',
                params: { detail: row, ClaimHeader: this.$t('osm.Claim.edit.header') }
              });
              break;
          }
          break;

          // Renewal
        case "R":
          this.$router.push({
            name: 'Notification Router',
            params: {
              currentCategory: type,
              reminderDate: data.reminderDate,
            }
          });
          break;

          // Renewal
        case "A":
          this.currentAppointmentID = data.ID;
          this.openModal('edit');
          break;


        default:
          alert("Cannot find event type: " + type);
          break;
      }
    }
  },
  created(){
    this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });

  },
  mounted() {},
  watch: {
    selectedCustomer(val) {
      if (val) {
        Vue.set(this.form, 'customerID', val.ID);
      } else {
        Vue.set(this.form, 'customerID', '');
      }
      // console.log(this.form.customerID);
    },
    vuexFinalResult(newData, oldData) {
      let result = newData;
      // console.log("Final Result: "+newData);
      if (result) {
        this.modalOnClick();
        // this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset', true);
      }
  },
    },
  data() {
    return {
      form: {
        meetingDate: '',
        meetingTime: '',
        event: '',
        remarks: '',
        customerID: '',
        meetingAddress: ''
      },
      allDayFlag: false,
      selectedCustomer: { ID: -1 },
      modalType: 'create',
      modalAction:'',
      currentAppointmentID:'',
      customerAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'customer' }],
        showItems: ['englishFullname', 'chineseFullname'],
      },
      eventIndicator: {
        textColor: '#333',
        borderColor: 'transparent',
        events: {
          birthday: { messageType: 'B', content: this.$t('crm.calendar.indicator.birthday'), backgroundColor: '#FEF5AE' },
          service: { messageType: 'S', content: this.$t('crm.calendar.indicator.serviceRequest'), backgroundColor: '#ffc977' },
          appointment: { messageType: 'A', content: this.$t('crm.calendar.indicator.appointment'), backgroundColor: '#dfb4ff' },
          renewal: { messageType: 'R', content: this.$t('crm.calendar.indicator.renewal'), backgroundColor: 'rgb(255,188,188)' }, // (255,188,188),(255,66,66)
          life: { messageType: 'P', content: this.$t('crm.calendar.indicator.life'), backgroundColor: '#B0D6FA' },
          GI: { messageType: 'G', content: this.$t('crm.calendar.indicator.gi'), backgroundColor: '#9EF0CE' },
          claim: { messageType: 'C', content: this.$t('crm.calendar.indicator.claim'), backgroundColor: '#DCDCDC' },
        }
      },
      events: [],
      calEvent:'',
      calElement:'',
      eventInformations: [],
      config: {
        header: {
          left: 'prev,next',
          center: 'title',
          right: ''
        },
        defaultView: 'month',
        themeSystem: 'bootstrap4',
        editable: false,
        selectable: false,
        eventLimit: 3,
        viewRender: (event, element) => {
          this.calEvent = event;
          this.calElement = element;

          // console.log(this.calEvent);
          // console.log(this.calElement);
          this.getAllCalendar();

        },
        eventRender: (event, element) => {
          // console.log(event)
        },
        eventLimitClick: (calEvent, jsEvent) => {
          setTimeout(function() {
            $(".fc-more-popover").css({ "overflow-y": "scroll" });
          }, 20);
          return "popover";
        },
        eventClick: (calEvent, jsEvent, view) => {
          jsEvent.preventDefault();
          this.directToDetail(calEvent.url);
          return false;
        }
      },
    }
  }
}

</script>
<style>
.fc-event {
  text-align: center !important;
  padding-top: 3px;
  padding-bottom: 3px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-weight: 500;
}

.birthdayEvent {
  background-color: #000000 !important;
}

.fc-more-popover {
  max-height: 400px;
  width: 300px !important;
  /*  overflow-y: scroll !important;
*/
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Calendar/CalendarView.vue